<!-- Only show the file name and diff navigation icons when the diff editor is loaded in a modal -->
<ng-container *ngIf="vcsService.isTwoWayModalOpened || mergeService.openThreeWayDialog">
    <div style="display: flex;flex-direction: row;align-items: center;"
        [ngClass]="{'diff-file-path':mergeService.openThreeWayDialog}">
        <p class="app-label" style="margin: 0;"> {{locale['LABEL_FILE']}}: {{isTwoWay?
            diffFileContent?.filePath:conflictedFileDiff.filePath}}
        </p>
        <div class="diff-nav-icons"><i class="wm-icon12 wms wms-arrow-up" title="Previous Diff"
                (click)="vcsService.goToPrevDiff()"></i><i class="wm-icon12 wms wms-arrow-down" title="Next Diff"
                (click)="vcsService.goToNextDiff()"></i></div>
    </div>
</ng-container>
<!-- Header for the 2 way diff editor -->
<div id="diff-title" *ngIf="vcsService.isTwoWayModalOpened">
    <label class="app-label" style="width: 50%">{{locale['LABEL_VCS_SERVER_VERSION']}}</label>
    <label class="app-label" style="width: 50%">{{vcsService.isViewingDiffFromCommitHistory
        ?locale['LABEL_VCS_COMMIT_VERSION']:locale['LABEL_VCS_YOUR_VERSION']}}</label>
</div>
<!-- Header for the 3 way diff editor -->
<div class="merge-header" *ngIf="mergeService.openThreeWayDialog">
    <div><label class="app-label">{{locale['LABEL_CHANGES_FROM_'+mergeService.mergeOperationType] || locale.LABEL_VCS_MERGE_CHANGES_FROM_SERVER}}</label></div>
    <div class="merge-result-header"><label class="app-label">{{locale.LABEL_VCS_MERGE_RESULT}}</label>
    </div>
    <div><label class="app-label">{{locale.LABEL_VCS_LOCAL_CHANGES}}</label></div>
</div>
<div #wmsDiffEditor id="editor"></div>
